import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import './PageBackgroundColor.css';
import ParentCategory from './parent-category/ParentCategory';

class PageBackgroundColor extends Component {
  constructor(args) {
    super(args);
  }


  backgroundPicker = () => {
    const {
      lang,
      pagesById,
      layouts,
      backgrounds,
    } = this.props;

    return <ParentCategory backgrounds={backgrounds} layouts={layouts} pagesById={pagesById} lang={lang} />;
  }

  render() {
    return (
      <div>
        { this.backgroundPicker() }
      </div>
    );
  }
}

PageBackgroundColor.defaultProps = {
  lang: {},
  pagesById: {},
  layouts: {},
};

PageBackgroundColor.propTypes = {
  lang: PropTypes.object,
  pagesById: PropTypes.object,
  layouts: PropTypes.object,
};

export default connect(state => ({
  pagesById: state.entities.pages.byId,
  layouts: state.entities.layouts.byId,
  backgrounds: state.backgrounds.backgrounds,
}))(PageBackgroundColor);



// WEBPACK FOOTER //
// ./src/components/top-bar/top-bar-buttons/colors/page-background-color/PageBackgroundColor.jsx